<template>
    <div class="groupDetail pages">
        <div class="content1">
            <div class="d1">
                <p class="t">
                    <span><img src="../../assets/images/newIcon/vipgroup_configuration_icon.png" alt="">基础数据</span>
                    <span> 
                        <img @click="open2" src="../../assets/images/newIcon/updata_icon.png" alt="">
                        <img @click="edit" src="../../assets/images/newIcon/details_customerbianji_icon.png" alt="">
                        <img @click="del" src="../../assets/images/newIcon/delete_icon.png" alt="">
                    </span>
                </p>
                <el-form class="forms" ref="form" label-position="right" label-width="90px">
                    <el-form-item label="群组名称：">
                        <img src="../../assets/images/newIcon/vipgroup_defaultgroup_icon.png" alt="">
                        <span>群组名称</span>
                    </el-form-item>
                    <el-form-item label="群组描述：">
                        <span>群组描述文字</span>
                    </el-form-item>
                    <el-form-item label="业务系统：">
                        <span>颐安中台</span>
                    </el-form-item>
                    <el-form-item label="创建人：">
                        <span>吴彦祖</span>
                    </el-form-item>
                    <el-form-item label="人员数量：">
                        <span>10000人</span>
                    </el-form-item>
                    <el-form-item label="创建方式：">
                        <span>标签创建/规则创建/混合创建</span>
                    </el-form-item>
                    <el-form-item label="刷新方式：">
                        <span>手动更新/例行更新</span>
                    </el-form-item>
                </el-form>
            </div>
            <div class="d2">
                <p class="t">
                    <span><img src="../../assets/images/newIcon/vip_viplabel_icon.png" alt="">会员标签</span>
                    <span>
                    </span>
                </p>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="全部" name="1"></el-tab-pane>
                    <el-tab-pane label="运营标签" name="2"></el-tab-pane>
                    <el-tab-pane label="规则标签" name="3"></el-tab-pane>
                </el-tabs>
                <p class="tags">
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                    <el-tag size="medium">中等标签</el-tag>
                </p>
            </div>
            <div class="d3">
                <p class="t">
                    <span>
                        <img src="../../assets/images/newIcon/group_grouprules_icon.png" alt="">群组规则
                    </span>
                    <span>
                        
                    </span>
                </p>
                <ul class="lis">
                    <li class="l">
                        <img src="../../assets/images/newIcon/useattribute_icon.png" alt="">
                        <span>用户属性满足</span>
                        <span class="xl">
                            <i v-if="activeType!=1" @click="activeType=1" class="el-icon-arrow-down"></i>
                            <i v-if="activeType==1" @click="activeType=0" class="el-icon-arrow-up"></i>
                        </span>
                    </li>
                    <transition name="normal-expand">
                    <li class="li" v-show="activeType==1" style="height:600px;" >
                        <div class="c">
                            <p class="icons">
                                <span>A</span>
                            </p>
                            <div>
                                <p class="title">VIP等级包含</p>
                                <p class="dj">
                                    <span>黄金会员</span>
                                    <span>黄金会员</span>
                                </p>
                            </div>
                        </div>
                        <div class="c">
                            <p class="icons">
                               <span>B</span>
                            </p>
                            <div>
                                <p class="title">性别 为</p>
                                <p class="xb">
                                    <span>男</span>
                                </p>
                            </div>
                        </div>
                        <div class="c">
                            <p class="icons">
                               <span>C</span>
                            </p>
                            <div>
                                <p class="title">来源渠道 包含</p>
                                <p class="qd">
                                    <span class="ft">小程序</span>
                                    <span class="f">
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                    </span>
                                    <span class="ft">自然注册</span>
                                    <span class="text">
                                        选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                                    </span>
                                    <span class="ft">自定义渠道</span>
                                    <span class="f">
                                        <span>公众号模版消息</span>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </li>
                    </transition>
                    <li  class="l" >
                        <img src="../../assets/images/newIcon/usebehavior_icon.png" alt="">
                        <span>用户行为满足</span>
                        <span class="xl">
                            <i v-if="activeType!=2" @click="activeType=2" class="el-icon-arrow-down"></i>
                            <i v-if="activeType==2" @click="activeType=0" class="el-icon-arrow-up"></i>
                        </span>
                    </li>
                    <transition name="normal-expand">
                    <li v-show="activeType==2" style="height:600px;"  class="li">
                    <div class="c">
                        <p class="icons">
                            <span>A</span>
                        </p>
                        <div>
                            <p class="title">VIP等级包含</p>
                            <p class="dj">
                                <span>黄金会员</span>
                                <span>黄金会员</span>
                            </p>
                        </div>
                    </div>
                    <div class="c">
                        <p class="icons">
                            <span>B</span>
                        </p>
                        <div>
                            <p class="title">性别 为</p>
                            <p class="xb">
                                <span>男</span>
                            </p>
                        </div>
                    </div>
                    <div class="c">
                        <p class="icons">
                            <span>C</span>
                        </p>
                        <div>
                            <p class="title">来源渠道 包含</p>
                            <p class="qd">
                                <span class="ft">小程序</span>
                                <span class="f">
                                    <span>小程序模版消息</span>
                                    <span>小程序模版消息</span>
                                    <span>小程序模版消息</span>
                                    <span>小程序模版消息</span>
                                </span>
                                <span class="ft">自然注册</span>
                                <span class="text">
                                    选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                                </span>
                                <span class="ft">自定义渠道</span>
                                <span class="f">
                                    <span>公众号模版消息</span>
                                </span>
                            </p>
                        </div>
                    </div>
                    </li>
                    </transition>
                    <li class="l">
                        <img src="../../assets/images/newIcon/usebusiness_icon.png" alt="">
                        <span>用户业务规则满足</span>
                         <span class="xl">
                            <i v-if="activeType!=3" @click="activeType=3" class="el-icon-arrow-down"></i>
                            <i v-if="activeType==3" @click="activeType=0" class="el-icon-arrow-up"></i>
                        </span>
                    </li>
                    <transition name="normal-expand">
                     <li v-show="activeType==3" style="height:600px;" class="li">
                        <div class="c">
                            <p class="icons">
                                <span>A</span>
                            </p>
                            <div>
                                <p class="title">VIP等级包含</p>
                                <p class="dj">
                                    <span>黄金会员</span>
                                    <span>黄金会员</span>
                                </p>
                            </div>
                        </div>
                        <div class="c">
                            <p class="icons">
                               <span>B</span>
                            </p>
                            <div>
                                <p class="title">性别 为</p>
                                <p class="xb">
                                    <span>男</span>
                                </p>
                            </div>
                        </div>
                        <div class="c">
                            <p class="icons">
                               <span>C</span>
                            </p>
                            <div>
                                <p class="title">来源渠道 包含</p>
                                <p class="qd">
                                    <span class="ft">小程序</span>
                                    <span class="f">
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                        <span>小程序模版消息</span>
                                    </span>
                                    <span class="ft">自然注册</span>
                                    <span class="text">
                                        选择“自然注册”后，将筛选出通过自然搜索注册小程序与app的客户～
                                    </span>
                                    <span class="ft">自定义渠道</span>
                                    <span class="f">
                                        <span>公众号模版消息</span>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </li>
                    </transition>
                </ul>
            </div>
        </div>
        <div class="content2">
            <div class="d1 mb-30">
                <div class="title">
                    <div class="t1">
                        <p>
                            <img class="log" src="../../assets/images/newIcon/vipgroup_updaterecord_icon.png" alt="">
                            更新记录
                            <el-tooltip class="item" effect="dark" content="创建群组时选择自动更新则系统会根据规则自动更新群组数量，可在详情中查看更新记录" placement="right">
                                <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                            </el-tooltip>
                        </p>
                    </div>
                    <div class="t2">
                        <p>
                            2021.10.10 18:00:00更新群组
                        </p> 
                        <p>
                            <img src="../../assets/images/newIcon/ss_shaixuan_icon.png" alt="">
                            <el-select style="width:100px" v-model="value" placeholder="请选择">
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </p>
                    </div>
                </div>
                <div  id="survey"></div>
            </div>
            <div class="d2">
                <div class="title">
                    <div class="t1">
                        <p>
                            <img class="log" src="../../assets/images/newIcon/groupvip_thing_icon.png" alt="">
                            群组事件
                        </p>
                    </div>
                    <div class="t2">
                        <p>
                            <el-tabs v-model="activeName2" @tab-click="handleClick">
                                <el-tab-pane label="已完成" name="1"></el-tab-pane>
                                <el-tab-pane label="进行中" name="2"></el-tab-pane>
                                <el-tab-pane label="待开始" name="3"></el-tab-pane>
                            </el-tabs>
                        </p> 
                        <p>
                            <img src="../../assets/images/newIcon/ss_shaixuan_icon.png" alt="">
                            <el-select style="width:100px" v-model="value2" placeholder="请选择">
                                <el-option
                                v-for="item in options2"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </p>
                    </div>
                     <ul v-if="activeName2==1">
                        <li>
                            <div class="l1">
                                <div>
                                    <span>
                                        <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                        24小时签到打卡
                                    </span>
                                    <span class="b">
                                        人群
                                    </span>
                                </div>
                                <div>
                                    <span>创建时间：</span>
                                    <span class="c3">2021.07.09 16:53</span>
                                </div>
                                <div>
                                    <span>状      态：</span>
                                    <span class="c0091FF">完成</span>
                                </div>
                                <div class="jdt">
                                    <span>目标完成率：</span>
                                    <el-progress :percentage="20" ></el-progress>
                                </div>
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="l1">
                                <div>
                                    <span>
                                        <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                        30天未登录的付费用户召回
                                    </span>
                                    <span class="b">
                                        人群
                                    </span>
                                </div>
                                <div>
                                    <span>创建时间：</span>
                                    <span class="c3">2021.07.09 16:53</span>
                                </div>
                                <div>
                                    <span>状      态：</span>
                                    <span class="c0091FF">完成</span>
                                </div>
                                <div class="jdt">
                                    <span>目标完成率：</span>
                                    <el-progress :percentage="20" ></el-progress>
                                </div>
                                
                                
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="l1">
                                <div>
                                    <span>
                                        <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                        24小时签到打卡
                                    </span>
                                    <span class="b">
                                        人群
                                    </span>
                                </div>
                                <div>
                                    <span>创建时间：</span>
                                    <span class="c3">2021.07.09 16:53</span>
                                </div>
                                <div>
                                    <span>状      态：</span>
                                    <span class="c0091FF">完成</span>
                                </div>
                                <div class="jdt">
                                    <span>目标完成率：</span>
                                    <el-progress :percentage="20" ></el-progress>
                                </div>
                                
                                
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="l1">
                                <div>
                                    <span>
                                        <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                        24小时签到打卡
                                    </span>
                                    <span class="b">
                                        人群
                                    </span>
                                </div>
                                <div>
                                    <span>创建时间：</span>
                                    <span class="c3">2021.07.09 16:53</span>
                                </div>
                                <div>
                                    <span>状      态：</span>
                                    <span class="c0091FF">完成</span>
                                </div>
                                <div class="jdt">
                                    <span>目标完成率：</span>
                                    <el-progress :percentage="20" ></el-progress>
                                </div>
                                
                                
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="l1">
                                <div>
                                    <span>
                                        <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                        24小时签到打卡
                                    </span>
                                    <span class="b">
                                        人群
                                    </span>
                                </div>
                                <div>
                                    <span>创建时间：</span>
                                    <span class="c3">2021.07.09 16:53</span>
                                </div>
                                <div>
                                    <span>状      态：</span>
                                    <span class="c0091FF">完成</span>
                                </div>
                                <div class="jdt">
                                    <span>目标完成率：</span>
                                    <el-progress :percentage="20" ></el-progress>
                                </div>
                                
                                
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="l1">
                                <div>
                                    <span>
                                        <img src="../../assets/images/newIcon/jimu_people_icon.png" alt="">
                                        24小时签到打卡
                                    </span>
                                    <span class="b">
                                        人群
                                    </span>
                                </div>
                                <div>
                                    <span>创建时间：</span>
                                    <span class="c3">2021.07.09 16:53</span>
                                </div>
                                <div>
                                    <span>状      态：</span>
                                    <span class="c0091FF">完成</span>
                                </div>
                                <div class="jdt">
                                    <span>目标完成率：</span>
                                    <el-progress :percentage="20" ></el-progress>
                                </div>
                                
                                
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                    </ul>
                    <div v-if="activeName2==2" class="b2">
                        <ul>
                        <li>
                            <div class="d1">
                            <div>
                                <span class="txt-left">
                                <img
                                    style="
                                    display: inline-block;
                                    transform: translate(0px, 3px);
                                    "
                                    src="../../assets/images/newIcon/jimu_people_icon.png"
                                    alt=""
                                />
                                挽回流失用户
                                </span>
                                <span class="b"> 人群 </span>
                            </div>
                            <div>
                                <span>创建时间：</span>
                                <span class="c3">2021.07.09 16:53</span>
                            </div>
                            <div>
                                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                                <span class="colorGree">执行中</span>
                            </div>
                            <div class="jdt"></div>
                            <div class="time">
                                <span>最新触发时间：</span>
                                <span class="c3">2021.07.09 16:53</span>
                            </div>
                            <div class="d33">
                                <div>
                                <p class="blueColor">33.00%</p>
                                <p class="target">
                                    目标完成率比前一天<span class="downColor"
                                    >5.9%<i class="el-icon-bottom"></i
                                    ></span>
                                </p>
                                </div>
                                <div id="y1" style="margin-top: 10px; margin-left: -30px"></div>
                            </div>
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="d1">
                            <div>
                                <span class="txt-left">
                                <img
                                    style="
                                    display: inline-block;
                                    transform: translate(0px, 3px);
                                    "
                                    src="../../assets/images/newIcon/jimu_people_icon.png"
                                    alt=""
                                />
                                挽回流失用户
                                </span>
                                <span class="b"> 人群 </span>
                            </div>
                            <div>
                                <span>创建时间：</span>
                                <span class="c3">2021.07.09 16:53</span>
                            </div>
                            <div>
                                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                                <span class="colorGree">执行中</span>
                            </div>
                            <div class="jdt"></div>
                            <div class="time">
                                <span>最新触发时间：</span>
                                <span class="c3">2021.07.09 16:53</span>
                            </div>
                            <div class="d33">
                                <div>
                                <p class="blueColor">33.00%</p>
                                <p class="target">
                                    目标完成率比前一天<span class="downColor"
                                    >5.9%<i class="el-icon-bottom"></i
                                    ></span>
                                </p>
                                </div>
                                <div id="y2" style="margin-top: 10px; margin-left: -30px"></div>
                            </div>
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="d1">
                            <div>
                                <span class="txt-left">
                                <img
                                    style="
                                    display: inline-block;
                                    transform: translate(0px, 3px);
                                    "
                                    src="../../assets/images/newIcon/jimu_people_icon.png"
                                    alt=""
                                />
                                挽回流失用户
                                </span>
                                <span class="b"> 人群 </span>
                            </div>
                            <div>
                                <span>创建时间：</span>
                                <span class="c3">2021.07.09 16:53</span>
                            </div>
                            <div>
                                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                                <span class="colorGree">执行中</span>
                            </div>
                            <div class="jdt"></div>
                            <div class="time">
                                <span>最新触发时间：</span>
                                <span class="c3">2021.07.09 16:53</span>
                            </div>
                            <div class="d33">
                                <div>
                                <p class="blueColor">33.00%</p>
                                <p class="target">
                                    目标完成率比前一天<span class="downColor"
                                    >5.9%<i class="el-icon-bottom"></i
                                    ></span>
                                </p>
                                </div>
                                <div id="y3" style="margin-top: 10px; margin-left: -30px"></div>
                            </div>
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        
                        </ul>
                    </div>
                    <div v-if="activeName2==3" class="b2">
                        <ul>
                        <li>
                            <div class="d1">
                            <div>
                                <span class="txt-left">
                                <img
                                    style="
                                    display: inline-block;
                                    transform: translate(0px, 3px);
                                    "
                                    src="../../assets/images/newIcon/jimu_people_icon.png"
                                    alt=""
                                />
                                提升用户留资下单
                                </span>
                                <span class="b"> 人群 </span>
                            </div>
                            <div>
                                <span>创建时间：</span>
                                <span class="c3" style="color:#333;">2021.07.09 16:53</span>
                            </div>
                            <div>
                                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                                <span class="">待开始</span>
                            </div>
                            <div class="time">
                                <span>触达人数：</span>
                                <span class="c3">—</span>
                            </div>
                          
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="d1">
                            <div>
                                <span class="txt-left">
                                <img
                                    style="
                                    display: inline-block;
                                    transform: translate(0px, 3px);
                                    "
                                    src="../../assets/images/newIcon/jimu_people_icon.png"
                                    alt=""
                                />
                                提升用户留资下单
                                </span>
                                <span class="b"> 人群 </span>
                            </div>
                            <div>
                                <span>创建时间：</span>
                                <span class="c3" style="color:#333;">2021.07.09 16:53</span>
                            </div>
                            <div>
                                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                                <span class="">待开始</span>
                            </div>
                            <div class="time">
                                <span>触达人数：</span>
                                <span class="c3">—</span>
                            </div>
                          
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        <li>
                            <div class="d1">
                            <div>
                                <span class="txt-left">
                                <img
                                    style="
                                    display: inline-block;
                                    transform: translate(0px, 3px);
                                    "
                                    src="../../assets/images/newIcon/jimu_people_icon.png"
                                    alt=""
                                />
                                提升用户留资下单
                                </span>
                                <span class="b"> 人群 </span>
                            </div>
                            <div>
                                <span>创建时间：</span>
                                <span class="c3" style="color:#333;">2021.07.09 16:53</span>
                            </div>
                            <div>
                                <span>状&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp态：</span>
                                <span class="">待开始</span>
                            </div>
                            <div class="time">
                                <span>触达人数：</span>
                                <span class="c3">—</span>
                            </div>
                          
                            </div>
                            <div class="l2">
                                <p>
                                    <img src="../../assets/images/newIcon/jimu_fupan_icon.png" alt="">
                                    去复盘
                                </p>
                                <p>
                                    <img src="../../assets/images/newIcon/copy_icon.png" alt="">
                                    去复制
                                </p>
                            </div>
                        </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            activeType:1,
            activeName2:'1',
            activeName:"1",
            options:[{name:'昨日',value:1},{name:'近30天',value:2},{name:'近60天',value:3},{name:'近90天',value:4}],
            options2:[{name:'单次计划',value:1},{name:'重复计划',value:2}],
            value:"",
            value2:"",
            datas: [
                { data: "6.21", name: "新增客户数", val: 1000 },
                { data: "6.22", name: "新增客户数", val: 750 },
                { data: "6.23", name: "新增客户数", val: 270 },
                { data: "6.24", name: "新增客户数", val: 380 },
                { data: "6.25", name: "新增客户数", val: 250 },
                { data: "6.26", name: "新增客户数", val: 250 },
            ],
        }
    },
    mounted() {
        this.init2();
       
    },
    methods: {
        init(id, data, height) {
            const chart = new this.$chart({
                container: id,
                autoFit: true,
                width: 100,
                height: height || 300,
            });
            // chart
            // .interval({
            //     theme: {
            //     defaultColor: 'red',
            //     },
            // })
            // .position(0);
            chart.data(data);
            chart.scale({
                month: {
                range: [0, 1],
                },
                temperature: {
                nice: true,
                },
            });
            chart.scale("val", {
                min: 0,
                max: 1000,
            });
            chart.tooltip(false); //关闭提示信息
            chart.axis(false); // 关闭坐标轴
            // 隐藏图例
            chart.legend(false);
            chart.line().position("data*val").shape("smooth").color("name");
            // chart.point().position("data*val").shape("circle");
            chart.render();
        },
        open2() {
            this.$message({
            message: '刷新成功',
            type: 'success'
            });
        },

        del(){
             this.$confirm("是否确定删除", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                roundButton: true,
                type: "warning",
            }).then(() => {
                this.$message({
                type: "success",
                message: "删除成功!",
                });
            });
        },
        edit(){
            this.$router.push({name:"newMemberGroup",query:{id:"1111"}})
        },
        init2(){
            let d1=[
                {data:"01.01",name:'群组人数',val:1000},
                {data:"01.02",name:'群组人数',val:600},
                {data:"01.03",name:'群组人数',val:700},
                {data:"01.04",name:'群组人数',val:300},
                {data:"01.05",name:'群组人数',val:200},
                {data:"01.06",name:'群组人数',val:300},
            ]
            let data=[...d1];
            const chart = new this.$chart({
            container: 'survey',
            autoFit: true,
            height: 300,
            padding: [20,60,80,60],
            });
            // chart
            // .interval({
            //     theme: {
            //     defaultColor: 'red',
            //     },
            // })
            // .position(0);
            chart.data(data);
            chart.scale({
            month: {
                range: [0, 1],
            },
            temperature: {
                nice: true,
            },
            });

            chart.tooltip({
            showCrosshairs: true,
            shared: true,
            showMarkers: true,
            });
            chart.axis('val', {
            label: {
                formatter: (val) => {
                return val;
                },
            },
            });

            chart
            .line()
            .position('data*val')
            .color('name',["#5B8FF9","#B959F6",'#FF9D4D'])
            .shape('smooth')

            chart.render();
        },
        handleClick(e){
            console.log(e.name);
            if(e.name!=this.types){
                 this.types=e.name;
                if(e.name==2){
                    this.$nextTick(()=>{
                        this.init("y1", this.datas, 100);
                        this.init("y2", this.datas, 100);
                        this.init("y3", this.datas, 100);
                    })
                
                }
            }
           
        },
    },
}
</script>
<style lang="less" scoped>
    .normal-expand-enter-active,
    .normal-expand-leave-active{
        transition:all 1s ease;
        overflow: hidden;
        // height: 550px !important;
    }
    .normal-expand-enter,
    .normal-expand-leave-to {
        overflow: hidden;
        height: 0px !important;
    }
    .txt-left {
    text-align: left !important;
  }
    .colorGree {
        font-family: PingFangSC-Medium, PingFang SC !important;
        font-weight: 00 !important;
        color: #3e7603 !important;
    }
    .downColor {
        color: #19e9aa !important;
        text-align: left !important;
    }
    .blueColor {
        color: #3977fe !important;
        font-size: 20px;
        font-weight: 500;
    }
    .groupDetail{
        display: flex;
        justify-content: space-between;
        .xl{
            position: absolute;
            right:30px;
            i{
                font-size:18px;
            }
        }
        .content1{
            padding:30px;
            width:392px;
            box-sizing: border-box;
            background: #fff;
            .t{
                margin-bottom:30px;
                span{
                    &:first-child{
                        img{
                            margin-right:10px;
                        }
                    }
                }
                display: flex;
                justify-content: space-between;
                img{
                    width:20px;
                    height:20px;
                    vertical-align: middle;
                    margin-right:15px;
                    &:last-child{
                        margin:0;
                    }
                }
            }
            .d1{
                border-bottom:1px solid #E8E8E8;
                
                .forms{
                    img{
                        margin-right:10px;
                        width:32px;
                        height:32px;
                        vertical-align: middle;
                    }
                }
                /deep/ .el-form-item__content{
                    padding-left:30px;
                }
            }
            .d2{
                padding-top:30px;
                padding-bottom:15px;
                border-bottom:1px solid #E8E8E8;
                /deep/ .el-tabs__nav-wrap::after{
                    display: none;
                }
                .tags{
                    padding-top:15px;
                    /deep/ .el-tag{
                        border-radius: 30px;
                        margin-bottom:10px;
                    }
                }
            }
            .d3{
                margin-top:30px;    
            }
            .d3 .lis{
                .l{
                    margin-bottom:30px;
                    padding:15px 30px;
                    border-radius: 6px;
                    background: #F1F1F1;
                    position: relative;
                    display: flex;
                    align-items: center;
                    img{
                        margin-right:15px;
                        width:34px;
                        height:34px;
                    } 
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                }
                // .actives{
                //    height: auto;
                   
                // }
                .hidden {
                    height:0 !important;
                    // margin-top:-600px;
                    // max-height: 0px;
                    // overflow: ;
                    transition: all .6s linear;
                }
                .draw-enter-active, .draw-leave-active {
                    transition: height .3s ease;
                }
                .draw-enter, .draw-leave-to{
                    height: 0;
                    overflow: hidden;
                    transition: height .3s ease;
                }
                .li{
                //    height:300px;
                    // margin-bottom:30px;
                    .c{
                        display: flex;
                        div{
                            padding-bottom:60px;
                        }
                        .icons{
                            display: block;
                            flex-shrink:0;
                            position: relative;
                            margin-right:30px;
                            span{
                                display: block;
                                
                                // margin-right:30px;
                                width: 24px;
                                height: 24px;
                                text-align: center;
                                line-height: 24px;
                                background: #DEEAFF;
                                border-radius: 2px;
                                font-size: 14px;
                                font-weight: 500;
                                color: #327EFF;
                            }
                            &::after{
                                content: '';
                                position: absolute;
                                top: 24px;
                                left: 10px;
                                background: #A3A3A3;
                                width: 1px;
                                height: 100%;
                            }
                            
                        }
                        &:last-child{
                            .icons{
                                &::after{
                                    display: none !important;
                                }
                            }
                            
                        }
                        .title{
                            font-size: 14px;
                            font-weight: 500;
                            color: #333333;
                        }
                        .dj {
                            padding-top:15px;
                            span{
                                margin-right:15px;
                                padding: 6px 12px;
                                background: rgba(250, 100, 0, 0.09);
                                border-radius: 16px;
                                font-size: 14px;
                                font-weight: 400;
                                color: #FF8E42;
                            }
                            
                        }
                        .xb{
                            padding-top:15px;
                            span{
                                padding: 6px 18px;
                                background: rgba(211, 236, 255, 0.47);
                                text-align: center;
                                border-radius: 16px;
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #0091FF;
                            }
                        }
                        .qd{
                            padding-top:15px;
                            .ft{
                                padding-bottom:15px;
                                display: block;
                                font-size: 14px;
                                font-weight: 400;
                                color: #333333;
                            }
                            .text{
                                padding-bottom:15px;
                                display: block;
                                font-size: 12px;
                                font-weight: 400;
                                color: #777777;
                            }
                            .f{
                                display: block;
                                span{
                                    margin-right:8px;
                                    margin-bottom:10px;
                                    display: inline-block;
                                    padding:6px 12px;
                                    font-size: 14px;
                                    font-weight: 400;
                                    color: #FFFFFF;
                                    background: #327EFF;
                                    border-radius: 16px;
                                }                           
                            }
                        }
                    }
                }
            }
        }
        .content2{
            width:calc(100% - 420px); 
            .b2,
            .b3,
            .b4 {
            position: relative;
            // &::before {
            //     content: "";
            //     width: 1px;
            //     height: 800px;
            //     background-color: #efefefff;
            //     position: absolute;
            //     right: 15px;
            // }
            // margin-top: 50px;
            ul {
                // overflow-x: hidden;
                // display: flex;

                li {
                //   margin-left: 100px;
                // width: 271px;
                // margin-top: 16px;
                margin-right: 30px;
                .l2{
                    background:#F7FAFF;
                }
                .d1 {
                    padding: 15px;
                    background: #F7FAFF;
                    & > div {
                    margin-bottom: 10px;
                    display: flex;
                    justify-content: space-between;
                    &:first-child {
                        margin-bottom: 10px;
                        img {
                        width: 16px;
                        }

                        span {
                        &:first-of-type {
                            width: 140px;
                        }
                        font-size: 14px;
                        font-weight: 500;
                        color: rgba(37, 49, 62, 0.85);
                        }
                        .b,
                        .c {
                        background: rgba(255, 174, 119, 0.3);
                        border-radius: 13px;
                        padding: 4px 15px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #ff812d;
                        }
                        .c {
                        background: rgba(85, 223, 215, 0.3);
                        color: #26c2b8;
                        }
                    }
                    .jdt {
                        align-items: center;
                    }
                    /deep/ .el-progress {
                        width: 72% !important;
                        margin: 0;
                        margin-top: 10px;
                    }
                    /deep/ .el-progress__text {
                        color: #327eff;
                    }
                    span {
                        font-size: 12px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        &:first-child {
                        display: inline-block;
                        width: 84px;
                        text-align: right;
                        }
                    }
                    }
                }
                .d33 {
                    display: flex;
                    .target {
                    font-size: 12px;
                    font-weight: 500;
                    color: #999999;
                    }
                }
                .jdt {
                    width: 100%;
                    height: 2px;
                    background:#fff;
                    // border: 2px solid #ffffff;
                    margin-bottom: 15px;
                }
                }
            }
            }
            .d1{
                box-sizing: border-box;
                padding:30px;
                background: #fff; 
            }
            .d2{
                height:calc(100% - 457px);
                box-sizing: border-box;
                padding:30px;
                background: #fff; 
                /deep/ .el-tabs__nav-wrap::after{
                    display: none;
                }
                .t2{
                    padding:0;
                }
                ul{
                    margin-top:15px;
                    
                    // display: flex;
                    li{
                        display: inline-block;
                        margin-right:2%;
                        margin-bottom:20px;
                        width:49%;
                        box-sizing: border-box;
                        background: rgba(50, 126, 255, 0.04);
                        border-radius: 6px;
                        &:nth-child(2n){
                            margin-right:0;
                        }
                    }
                    li{
                        .l1{
                            padding:15px;
                            div{
                                margin-bottom:10px;
                                display: flex;
                                justify-content: space-between;
                                &:first-child{
                                    margin-bottom:10px;
                                    img{
                                        width:16px;
                                        vertical-align: middle;
                                    }
                                    span{
                                        &:first-of-type{
                                            width:auto;
                                        }
                                        font-size: 14px;
                                        font-weight: 500;
                                        color: rgba(37, 49, 62, 0.85);
                                    }
                                    .b{
                                        background: rgba(255, 174, 119, 0.3);
                                        border-radius: 13px;
                                        padding:4px 15px;
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #FF812D;
                                    }
                                }
                                .jdt{
                                align-items: center;
                                }
                                /deep/ .el-progress{
                                    width:72% !important; 
                                    margin: 0;
                                        margin-top: 6px;
                                }
                                /deep/ .el-progress__text{
                                    color:#327EFF
                                }
                                span{
                                    
                                    font-size: 12px;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #999999;
                                    &:first-child{
                                        display: inline-block;
                                        width:80px;
                                        text-align: right;
                                    }
                                     &:last-child{
                                            color:#333;
                                        }
                                }
                            }
                            
                        }
                        .l2{
                            display: flex;
                            p{
                                padding:15px 0;
                                border-top:1px solid #ededed;
                                border-right:1px solid #ededed;
                                width:50%;
                                text-align: center;
                                font-size: 12px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #3285F8;
                                img{
                                    width:16px;
                                    height:16px;
                                    vertical-align: middle;
                                }
                                &:last-child{
                                    border-right:0;
                                }
                            }
                        }
                    }
                }
            }
        }
        .title{
            margin-bottom:0px;
            .t1{
                display: flex;
                justify-content: space-between;
                p{
                    .log{
                        width:20px;
                    }
                    img{
                        width:16px;
                        vertical-align: middle;
                        margin-right:10px;
                    }
                    /deep/ .el-input .el-input__inner{
                        background: #F6F6F9;
                        border:0px;
                    }
                    span{
                        font-size: 12px;
                        font-weight: 400;
                        color: #999999;
                        
                    }
                }
            }
            .t2{
                padding-left:30px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top:12px;
                font-size: 12px;
                font-weight: 400;
                color: #333333;
                p{
                    color: #999999;
                    img{
                        margin-right:15px;
                        width:18px;
                        height:18px;
                        vertical-align: middle;
                    }
                }
            }
        }
        .c0091FF{
            color:#0091FF !important;
        }
    }
    
</style>